import { useEffect } from 'react'

// Publishes scroll state as CSS variables/classes so components can react
// without re-rendering: --scroll-progress (0-1), --scroll-y, .is-scrolled, .is-far
export function useScrollEffects() {
  useEffect(() => {
    const root = document.documentElement
    let frame = 0

    const update = () => {
      frame = 0
      const y = window.scrollY
      const max = root.scrollHeight - window.innerHeight
      root.style.setProperty('--scroll-progress', max > 0 ? (y / max).toFixed(4) : '0')
      root.style.setProperty('--scroll-y', String(Math.round(y)))
      root.classList.toggle('is-scrolled', y > 24)
      root.classList.toggle('is-far', y > 900)
    }

    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [])
}
